import SlideTransition from './SlideTransition'

export { SlideTransition }
export default SlideTransition
